import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";

export const ProductCard = ({ product }) => {
  return (
    <Link
      to={`/product/${product.id}`}
      className="product-card bg-black/40 border border-white/10 group block"
      data-testid={`product-card-${product.id}`}
    >
      {/* Image */}
      <div className="relative aspect-[4/5] overflow-hidden">
        <img
          src={product.image_url}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        {/* Badges */}
        <div className="absolute top-3 left-3 flex flex-col gap-2">
          {product.is_new_arrival && (
            <Badge className="bg-[#39FF14] text-black label-text hover:bg-[#39FF14]">
              New
            </Badge>
          )}
          {product.is_featured && (
            <Badge className="bg-[#FF00FF] text-white label-text hover:bg-[#FF00FF]">
              Featured
            </Badge>
          )}
        </div>
        {/* Quick view overlay */}
        <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
          <span className="label-text text-[#39FF14] text-lg tracking-wider">View Details</span>
        </div>
      </div>

      {/* Info */}
      <div className="p-4">
        <p className="text-[#888] text-xs label-text mb-1">{product.category}</p>
        <h3 className="text-[#EDEDED] font-semibold text-lg mb-2 group-hover:text-[#39FF14] transition-colors">
          {product.name}
        </h3>
        <div className="flex items-center justify-between">
          <span className="text-[#39FF14] text-xl font-bold heading">
            ${product.price.toFixed(2)}
          </span>
          {product.colors && product.colors.length > 0 && (
            <span className="text-[#888] text-sm">
              {product.colors.length} colors
            </span>
          )}
        </div>
      </div>
    </Link>
  );
};
